// extracted by mini-css-extract-plugin
export var attribution = "_8v-4";
export var authorName = "_8v-5";
export var quote = "_8v-3";
export var testimonial = "_8v-2";
export var trustedBy = "_8v-0";
export var trustedByLabel = "_8v-1";